import React, { useEffect, useRef, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';
import circle from '../../../assets/images/free_circle.svg';
import stripe from '../../../assets/images/stripe.svg';
import secure from '../../../assets/images/secure.svg';
import BackToHome from '../BackToHome/BackToHome';
import { useDispatch, useSelector } from 'react-redux';
import { payment_modal } from '../../../Action/action';
import { gccCountries, VAT } from '../../../Utils/gccCountryandVat';

const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_KEY}`);

function StripeForms(props) {
  const ref = useRef();
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.menuReducer.profile);
  const plan = useSelector((state) => state.menuReducer.ft_plan);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const options = {
    clientSecret: props && props?.location?.state?.client_secret,
    // Fully customizable with appearance API.
    appearance: {
      /*...*/
    },
  };

  const handlePaymentChange = () => {
    window.history.back();
    dispatch(
      payment_modal(
        true,
        props?.location?.state?.product,
        props?.location?.state?.plan,
        props?.location?.state?.amount,
      ),
    );
  };

  const handlePlanChange = () => {
    window.history.back();
    dispatch(payment_modal(false));
  };

  const renderAmount = () => {
    if (gccCountries.includes(profile?.country)) {
      if (plan === 'ft') {
        return Number(1 + 1 * VAT).toFixed(2);
      } else {
        return Number(
          Number(props?.location?.state?.amount) +
          Number(props?.location?.state?.amount) * VAT,
        ).toFixed(2);
      }
    } else {
      return props?.location?.state?.plan === 'ft'
        ? 1
        : props?.location?.state?.amount || 0;
    }
  };

  return (
    <>
      <div className="stripePayment">
        <span className="stripePayment_heading">Confirm your plan</span>
        <div className="stripePayment_cards">
          <div className="stripePayment_container">
            <span className="stripePayment_title">Billing information</span>
            <p>Payment types</p>
            <div className="stripePayment_type">
              <span className="stripePayment_type-img">
                <img src={circle} alt="circle" />
                <img src={stripe} alt="stripe" />
              </span>
              {/* <span onClick={handlePaymentChange}>Change</span> */}
            </div>
            <Elements stripe={stripePromise} options={options}>
              <CheckoutForm reference={ref} loader={setLoader} />
            </Elements>
            <div className="stripePayment_security">
              <span className="stripePayment_security-text">
                <img src={secure} alt="lock" />
                Secure payment
              </span>
              <p>This is a secure 128-BIT SSL encrypted payment</p>
              <p className="stripePayment_powered">
                Powered by{' '}
                <img
                  className="stripePayment_powered-highlight"
                  src={stripe}
                  alt="stripe"
                />
              </p>
            </div>
          </div>
          <div className="paymentSelect_right">
            <div className="paymentSelect_right-title">
              <span>Your order summary</span>
              {/* <button onClick={handlePlanChange} className="CancelBtn">
                Change
              </button> */}
            </div>
            <div className="paymentSelect_right-summary">
              <p className="paymentSelect_right-summary_title">Product name</p>
              <p className="paymentSelect_right-summary_content">
                {props && props?.location?.state?.product}
              </p>
              <p className="paymentSelect_right-summary_title">Plan</p>
              <p className="paymentSelect_right-summary_content">
                {props && props?.location?.state?.plan === 'ft'
                  ? 'Free trial(starter)'
                  : props && props?.location?.state?.plan}
              </p>
              <p className="paymentSelect_right-summary_title">Billing</p>
              <p className="paymentSelect_right-summary_content">
                {props && props?.location?.state?.plan === 'PAYG' ? 'Daily' : 'Monthly'}
              </p>
            </div>
            {gccCountries.includes(profile?.country) && (
              <div className="vatContainer">
                <div className="vatContainer_item">
                  <span>Plan price</span>
                  <span>
                    $
                    {props?.location?.state?.plan === 'ft'
                      ? 1
                      : props?.location?.state?.amount || 0}
                  </span>
                </div>
                <div className="vatContainer_item">
                  <span>VAT (5%)</span>
                  <span>
                    <span className="vatContainer_currency">$</span>
                    {plan === 'ft'
                      ? parseFloat(1 * VAT).toFixed(2)
                      : parseFloat(props?.location?.state?.amount * VAT).toFixed(2)}
                  </span>
                </div>
              </div>
            )}
            <div className="paymentSelect_right-total">
              <span>Total</span>
              <span>${renderAmount()}</span>
            </div>
            <BackToHome
              width={'100%'}
              active={!loader}
              title={loader ? 'Loading...' : 'Confirm'}
              action={() => ref.current.click()}
            />
            <div className="paymentSelect_right-bottom">
              By continuing, you are agreeing that your subscription will be automatically
              renewed until you cancel.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StripeForms;
